import { useMemo } from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import '../../../monaco-setup';
import { GraphiQL } from 'graphiql';
import { createGraphiQLFetcher } from '@graphiql/toolkit';
import 'graphiql/style.css';
import { useAppSelector } from '../../../store';
import { selectToken } from '../../../store/features/auth/authSlice';
import './graphql.css';

export const Route = createFileRoute('/settings/api-docs/graphql')({
  component: GraphqlDocsPage,
});

export { GraphqlDocsPage };

const GRAPHQL_ENDPOINT = import.meta.env.VITE_GRAPHQL_URL || 'http://localhost:3001/graphql';

function GraphqlDocsPage(): JSX.Element {
  const token = useAppSelector(selectToken);

  // Queries run as the signed-in user by default (session token attached). The
  // headers editor lets an integrator override this with an API Key Bearer token.
  const fetcher = useMemo(
    () =>
      createGraphiQLFetcher({
        url: GRAPHQL_ENDPOINT,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }),
    [token]
  );

  return (
    <div className="graphql-docs-page">
      <header className="graphql-docs-header">
        <Link to="/settings/api-docs" className="graphql-docs-back">
          <forge-icon name="arrow_back" aria-hidden="true"></forge-icon>
          API Documentation
        </Link>
        <p className="forge-typography--body2">
          Read-only GraphQL API. Runs as your signed-in user by default. To use an API Key instead,
          add <code>{'{ "Authorization": "Bearer ea_…" }'}</code> in the Headers tab. A key needs
          the <code>*.read</code> scope.
        </p>
      </header>
      <div className="graphql-docs-explorer">
        <GraphiQL fetcher={fetcher} defaultEditorToolsVisibility="headers" />
      </div>
    </div>
  );
}
